export enum Path {
    ROOT = '',
    CALLBACK = 'callback',
    PRIVATE_OFFICE = 'private-office',
    ERROR = 'error',
    NOT_FOUND = 'not-found',
    BUSINESS_ERROR = 'business-error',
    BMG_ERROR = 'bmg-error',
    GBDUL_LEADER_ERROR = 'gbdul-leader-error',
    EMPLOYEE_PERMISSION_DENIED = 'employee-permission-denied',
    PERSON_INVALID_STATUS_ERROR = 'person-invalid-status',

    USER = 'user',
    USER_PROFILE = 'user/profile',
    USER_PROFILE_HISTORY = 'user/profile-history',
    USER_PROFILE_ACCESS_HISTORY = 'user/profile-access-history',
    USER_ESIGN = 'user/esign',

    ORGANIZATION = 'organization',
    ORGANIZATION_ACCREDITATION_DETAILS = 'organization/private-office/accreditations/details',
    ORGANIZATION_EMPLOYEES = 'organization/private-office/employees',
    ORGANIZATION_EMPLOYEES_ADD = 'organization/private-office/employees/employee-add',
    ORGANIZATION_ACCREDITATIONS_ADD = 'organization/private-office/accreditations/accreditation-add',
    ORGANIZATION_ACCREDITATIONS = 'organization/private-office/accreditations',
    ORGANIZATION_COID_ADD = 'organization/private-office/coid/coid-add',
    ORGANIZATION_COID_DETAILS = 'organization/private-office/coid/details',
    ORGANIZATION_COID = 'organization/private-office/coid',
    ORGANIZATION_SERVICES = 'organization/private-office/services',
    ORGANIZATION_PROVIDER_SETTINGS = 'organization/private-office/services/provider-settings',
    ORGANIZATION_SERVICES_CLIENT_DETAILS = 'organization/private-office/services/clients',
    ORGANIZATION_SERVICES_AUTHORITY_MATRIX_DETAILS = 'organization/private-office/services/authority-matrix',
    ORGANIZATION_DISPUTES = 'organization/private-office/disputes',
    ORGANIZATION_BILLING = 'organization/private-office/billing',
    ORGANIZATION_DISPUTES_ADD = 'organization/private-office/disputes/dispute-add',
    ORGANIZATION_SETTINGS = 'organization/settings',
    ORGANIZATION_ESIGN = 'user/organization-esign',
    ORGANIZATION_ESIGN_EMPLOYEE_HISTORY = 'user/organization-esign/employee/history',

    MODERATOR = 'moderator',
    MODERATOR_ACCREDITATIONS = 'moderator/private-office/accreditation-requests',
    MODERATOR_TARIFFS = 'moderator/private-office/tariffs',
    MODERATOR_TARIFFS_VENDOR = 'moderator/private-office/tariffs/vendor',
    MODERATOR_TARIFFS_AUTH = 'moderator/private-office/tariffs/auth',
    MODERATOR_TARIFFS_EDIT_AUTH = 'moderator/private-office/tariffs/edit-auth',
    MODERATOR_ACCREDITATION_DETAILS = 'moderator/private-office/accreditation-requests/details',
    MODERATOR_CLIENTS = 'moderator/private-office/all-clients',
    MODERATOR_CLIENT_DETAILS = 'moderator/private-office/all-clients/client-details',
    MODERATOR_BILLING_ORGANIZATION = 'moderator/private-office/billing-organizations',
    MODERATOR_BILLING_VENDOR = 'moderator/private-office/billing-vendors/matching',
    MODERATOR_BILLING_IDENTITY_VENDOR = 'moderator/private-office/billing-vendors/identity',
    MODERATOR_BILLING_REPORTS = 'moderator/private-office/billing-organizations/generate-report',
    MODERATOR_BILLING_VENDORS = 'moderator/private-office/billing-vendors',
    MODERATOR_BILLING_VENDOR_REPORTS = 'moderator/private-office/billing-vendors/generate-report',
    MODERATOR_FORBIDDEN = 'moderator/forbidden',
    MODERATOR_ORGANIZATION_GROUPING = 'moderator/private-office/all-clients/organization-grouping',

    API_HUB = 'hub',
    API_HUB_PROVIDER = 'hub/provider',

    ESIGN_VERIFY = 'esign/verify',
}

export const MODERATOR_PATHS: string[] = Object.values(Path).filter(it => it.startsWith('moderator')).map(path => `/${path}`);
export const ORGANIZATION_PATHS: string[] = Object.values(Path).filter(it => it.startsWith('organization')).map(path => `/${path}`);

export const USER_PATHS: string[] = Object.values(Path).filter(it => it.startsWith('user')).map(path => `/${path}`);
